// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__2AjOk","footer":"ChangeClinic_footer__3afEH"};